const black = '#000000';

export default black;
